import { create } from 'zustand';
import { apiService } from '../services/api';
import useUserStore from './userStore';

const useDailyRewardStore = create((set, get) => ({
	streak: null,
	loading: false,
	error: null,

	setStreak: (value) => set({ streak: value }),

	fetchStreak: async () => {
		set({ loading: true });
		try {
			console.log('Fetching streak...');
			const res = await apiService.getStreak();
			console.log('Streak response:', res);
			if (res.success) {
				set({ streak: res.data, error: null });
			} else {
				console.error('Streak error:', res.error);
				set({ error: res.error });
			}
		} catch (e) {
			console.error('Streak fetch error:', e);
			set({ error: 'Ошибка при загрузке серии' });
		} finally {
			set({ loading: false });
		}
	},

	claimStreakBonus: async () => {
		set({ loading: true });
		try {
			const res = await apiService.claimStreakBonus();
			const fetchUser = useUserStore.getState().fetchUser;
			if (res.success) {
				await fetchUser();
				await get().fetchStreak();
				return { success: true, tokens: res.data.tokensAwarded };
			}
			return { success: false, error: res.error };
		} finally {
			set({ loading: false });
		}
	},

	claimDaily: async () => {
		set({ loading: true });
		try {
			const res = await apiService.claimDailyReward();
			const fetchUser = useUserStore.getState().fetchUser;
			if (res.success) {
				await fetchUser();
				await get().fetchStreak();
				return { success: true, tokens: res.data.tokensAwarded };
			}
			return { success: false, error: res.error };
		} finally {
			set({ loading: false });
		}
	}
}));

export default useDailyRewardStore; 